var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['nf-wrapper', { 'error-page': _vm.hasNotFound }],attrs:{"id":"error-pages"}},[(_vm.hasNotFound)?_c('not-found'):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }